import React from 'react';
import styles from './copyRight.module.scss';

const copyRight = () => (
  <div className={[styles.container].join(' ')}>
    <p>Copyright ©  2021, Baby Dragon, Taiwan</p>
  </div>
)

export default copyRight;
